import { Injectable } from '@angular/core';
import { AssetImage, AssetImagesProviderService } from '@web/shared/ui';

@Injectable()
export class AppAssetImagesProviderService extends AssetImagesProviderService {
  public override rootDir(): string {
    return 'assets/images';
  }

  public override images(): Map<AssetImage, string> {
    /* prettier-ignore */
    return new Map<AssetImage, string>([
      [AssetImage.DefaultAvatar, 'default_avatar.jpg'],
      [AssetImage.MultimediaBroken, 'multimedia_broken.svg'],
      [AssetImage.MultimediaPlaceholder, 'multimedia_placeholder.svg'],
      [AssetImage.PureBeautyLogo, 'pure_beauty_logo.svg'],
      [AssetImage.PureBeautyLogoWhite, 'pure_beauty_logo_white.svg'],
      [AssetImage.SampleProfileImage, 'sample_profile_image.jpeg'],
      [AssetImage.SignInBackground, 'sign_in_background.jpg'],
    ]);
  }
}
